import { useEffect, useState } from 'react'
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Grow from '@mui/material/Grow';

const VideosStepper = ({videos}) => {
    const [activeStep, setActiveStep] = useState(0);
    
    useEffect(() => {
        // Set the active step based on the first video that is not completed
        const firstIncompleteVideo = videos.find((videoObj) => !videoObj.completed);
        if (firstIncompleteVideo) {
            setActiveStep(firstIncompleteVideo.order - 1); // Adjust for zero-based index
        } else {
            setActiveStep(videos.length - 1); // If all completed, set to last step
        }
    }, [videos]);

    // Don't render stepper if there are no videos or only one video
    if (!videos || videos.length <= 1) {
        return null;
    }
    return (
        <Stepper activeStep={activeStep} sx={{ mt: 5, mb: 5 }}>
            {videos.map((videoObj) => (
                <Grow in timeout={700 * videoObj.order} style={{ transformOrigin: '0 0 0' }}>
                    <Step key={videoObj.order} completed={videoObj.completed}>
                        <StepLabel>Video {videoObj.order}</StepLabel>
                    </Step>
                </Grow>
                
            ))}
        </Stepper>
    )
}

export default VideosStepper;